import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { ajax } from "@rails/ujs"

export default class extends Controller {
  static targets = ["unsequenced", "sequenced"]
  static values = { routeId: Number }

  connect() {
    this.sortables = [this.unsequencedTarget, this.sequencedTarget].map((list) => new Sortable(list, {
      group: "route-addresses",
      animation: 150,
      forceFallback: true,
      scrollSensitivity: 20,
      scrollSpeed: 20,
      revertOnSpill: true,
      onEnd: this.moved.bind(this)
    }))
  }

  disconnect() {
    this.sortables.forEach((sortable) => sortable.destroy())
    this.sortables = []
  }

  moved(event) {
    const addressId = event.item.dataset.id

    if (event.to === this.sequencedTarget) {
      ajax({
        url: `/admin/routes/${this.routeIdValue}/route_addresses/${addressId}/${event.newIndex}`,
        type: "POST"
      })
    } else if (event.from === this.sequencedTarget) {
      ajax({
        url: `/admin/routes/${this.routeIdValue}/route_addresses/${addressId}`,
        type: "DELETE"
      })
    }
  }
}
